import { get, post } from "./ajax";
import notificationToast from "./notification-toast.js";
export default class Live_Streaming_Api_Admin {
    constructor() {
        this.init();
    }

    init() {
        this.bindEvents();
        this.initializeSelect2();
        this.sliderOptionHandler();
        this.checkDefaultValues();
    }

    bindEvents() {
        // Add event listeners for API interactions
        jQuery(document).on('click', '.ls-api-action', this.handleApiAction.bind(this));
        
        // Banner and Slider events
        jQuery(document.body).on("click", "#streamit_api_banner_select_live_streaming", this.AddLiveStreamingBannerSection.bind(this));
        jQuery(document.body).on("click", "#streamit_api_add_slider_live_streaming", this.AddLiveStreamingSlider.bind(this));
        
        // Form submission
        jQuery(document.body).on("submit", "#st-admin-option-dashboard-live-streaming", this.liveStreamingSubmit.bind(this));

        // Slider filter change handler (updated to listen for select2:select on ID)
        jQuery(document.body).on("select2:select", "select[id^='live_streaming_select_filters_']", this.handleSliderFilterChange.bind(this));

        // Add event listener for slider post type changes
        jQuery(document.body).on("change", "select[id^='slider_post_type_']", this.handleSliderPostTypeChange.bind(this));
    }

    initializeSelect2() {
        jQuery('.streamit_api_select2').each(function () {
            if (!jQuery(this).hasClass('select2-initialized')) {
                jQuery(this).select2({
                    width: '100%'
                }).addClass('select2-initialized');
            }
        });
    }

    handleApiAction(e) {
        e.preventDefault();
        const $button = jQuery(e.currentTarget);
        const action = $button.data('action');
        const data = $button.data('params') || {};

        if (!action) return;

        post(action, data)
            .then(response => {
                if (response.success) {
                    this.handleSuccess(response, $button);
                } else {
                    this.handleError(response, $button);
                }
            })
            .catch(error => {
                this.handleError({ message: error.message }, $button);
            });
    }

    handleSuccess(response, $button) {
        if (response.message) {
            this.showNotice(response.message, 'success');
        }
        jQuery(document).trigger('ls_api_success', [response, $button]);
        if (response.refresh) {
            this.refreshData();
        }
    }

    handleError(response, $button) {
        const message = response.message || 'An error occurred';
        this.showNotice(message, 'error');
        jQuery(document).trigger('ls_api_error', [response, $button]);
    }

    showNotice(message, type = 'info') {
        const notice = jQuery('<div>', {
            class: `notice notice-${type} is-dismissible`,
            html: `<p>${message}</p>`
        });

        jQuery('.wrap').first().prepend(notice);
        setTimeout(() => {
            notice.fadeOut(() => notice.remove());
        }, 5000);
    }

    AddLiveStreamingBannerSection(event) {
        event.preventDefault();
        const button = jQuery(event.currentTarget);
        button.attr('disabled', true);

        // Find the closest parent that contains the banner sections
        const bannerSection = button.closest('.streamit_api_banner_section');

        var lastSource = bannerSection.find('.custom_dropdown_wrapper').last();
        
        var relValue = lastSource.attr('rel');
        if (relValue == undefined) {
            relValue = 0;
        } else {
            relValue = parseInt(relValue, 10) + 1;
        }
	
        let selectData = {
            selected_type: 'live_streaming',
            i: relValue
        }

        this.addbannertab(selectData, button, bannerSection);
    }

    addbannertab(data, button, bannerSection) {
        get('ls_add_banner_tab', {
            data: data,
            _ajax_nonce: LSAjax._ajax_nonce
        })
            .then(response => {
                if (response.success) {
                    if (bannerSection.length) {
                        // Check if response.data is an object with a data property
                        const html = typeof response.data === 'object' && response.data.data ? response.data.data : response.data;
                        bannerSection.append(html);
                        
                        // Initialize select2 after adding the banner
                        if (jQuery('.streamit_api_select2').length > 0) {
                            jQuery('.streamit_api_select2').each(function () {
                                if (!jQuery(this).hasClass('select2-initialized')) {
                                    jQuery(this).select2({
                                        width: '100%'
                                    }).addClass('select2-initialized');
                                }
                            });
                        }
                        
                        // Initialize media uploader for the new banner
                        if (typeof streamit_media_uploader !== 'undefined') {
                            streamit_media_uploader.init();
                        }
                        
                        button.attr('disabled', false);
                    }
                } else {
                    button.attr('disabled', false);
                }
            })
            .catch(error => {
                button.attr('disabled', false);
            });
    }

    AddLiveStreamingSlider(event) {
        
        event.preventDefault();
        const button = jQuery(event.currentTarget);
        button.attr('disabled', true);

        // Find the slider container using the correct ID
        const sliderSection = button.closest('.streamit_api_slider_section');
        
        const sliderList = sliderSection.find('#streamit_api_slider_list');
        
        if (!sliderList.length) {
            console.error('Could not find slider container. Available elements:', sliderSection.html());
            button.attr('disabled', false);
            return;
        }

        var lastSource = sliderList.find('.streamit_api_single_slider').last();
        var relValue = lastSource.attr('rel');

        if (relValue === undefined) {
            relValue = 0;
        } else {
            relValue = parseInt(relValue, 10) + 1;
        }

        var data = {
            i: relValue,
            type: 'live_streaming'
        };

        this.addslidertab(data, button, sliderList);
    }

    addslidertab(data, button, sliderList) {
        get('ls_add_slider_tab', {
            data: data,
            _ajax_nonce: LSAjax._ajax_nonce
        })
        .then(response => {
            if (response.success && response.data) {
                if (sliderList.length) {
                    // Check if response.data is an object with a data property
                    const html = typeof response.data === 'object' && response.data.data ? response.data.data : response.data;
                    sliderList.append(html);
                    
                    // Initialize select2 after adding the slider
                    if (jQuery('.streamit_api_select2').length > 0) {
                        jQuery('.streamit_api_select2').each(function () {
                            if (!jQuery(this).hasClass('select2-initialized')) {
                                jQuery(this).select2({
                                    width: '100%'
                                }).addClass('select2-initialized');
                            }
                        });
                    }
                    
                    // Ensure the initial filter state is correctly applied for the new slider
                    const newSlider = sliderList.find('.streamit_api_single_slider').last();
                    const relValue = newSlider.attr('rel');
                    const type = newSlider.find('#type').val();

                    if (type === 'live_streaming') {
                        const liveStreamingOptions = newSlider.find('.live_streaming_slider_options');
                        const filterSelect = newSlider.find(`#live_streaming_select_filters_${type}_${relValue}`);

                        if (filterSelect.length && liveStreamingOptions.length) {
                            const initialFilterValue = filterSelect.val();
                            this.OperateSliderrInnerSection(liveStreamingOptions[0], initialFilterValue);
                        }
                    }

                    button.attr('disabled', false);
                } else {
                    console.error('Slider list container not found');
                    button.attr('disabled', false);
                }
            }
            else {
                console.error('Invalid response format:', response);
                button.attr('disabled', false);
            }
        })
        .catch(error => {
            console.error('Error while adding slider tab:', error);
            button.attr('disabled', false);
        });
    }

    handleSliderFilterChange(event) {
        const select = jQuery(event.currentTarget);
        const value = select.val();
        const sliderContainer = select.closest('.streamit_api_single_slider');
        const liveStreamingOptions = sliderContainer.find('.live_streaming_slider_options');

        // Call the centralized function to manage visibility
        this.OperateSliderrInnerSection(liveStreamingOptions[0], value);
    }

    handleSliderPostTypeChange(event) {
        const select = jQuery(event.currentTarget);
        const value = select.val();
        const sliderContainer = select.closest('.streamit_api_single_slider');
        const relValue = sliderContainer.attr('rel');
        const postType = sliderContainer.find('#type').val();

        this.manageSliderOptions(value, select[0], postType, relValue);
    }

    sliderOptionHandler() {
        // Collect all the slider post type select elements
        const singleslider = document.querySelectorAll('.streamit_api_single_slider');

        // Loop through each slider container
        singleslider.forEach((slider) => {
            // Get the 'rel' attribute and #type element
            const rel_value = slider.getAttribute('rel');
            const post_type_element = slider.querySelector('#type');

            // Ensure the #type element exists and get its value
            if (post_type_element) {
                const post_type = post_type_element.value;

                // Only proceed if post type is live_streaming
                if (post_type === 'live_streaming') {
                    // Construct the dynamic selector for the post type element
                    const SelectPostTypeElement = '#slider_post_type_' + post_type + '_' + rel_value;
                    // Query the DOM for elements matching the dynamic selector
                    const sliderPostTypes = slider.querySelector(SelectPostTypeElement);

                    // Ensure sliderPostTypes exists before proceeding
                    if (sliderPostTypes) {
                        // Pass the element directly to manageSliderOptions for initial setup
                        // This will ensure the correct filter options are displayed when the slider post type is selected.
                        this.manageSliderOptions(sliderPostTypes.value, sliderPostTypes, post_type, rel_value);

                        // Removed redundant event listener for select2:select here,
                        // as bindEvents already handles it globally.
                    }
                }
            }
        });
    }

    checkDefaultValues() {
        // Ensure DOM is fully loaded
        jQuery(document).ready(() => {
            // Get all sliders
            const sliders = jQuery('.streamit_api_single_slider');
            
            sliders.each((index, slider) => {
                const currentSlider = jQuery(slider);
                const relValue = currentSlider.attr('rel');
                const postType = currentSlider.find('#type').val() || '';
                const sliderPostType = currentSlider.find(`#slider_post_type_${postType}_${relValue}`).val() || '';

                
                // Only proceed if post type is live_streaming or home with live_streaming selected
                if (postType === 'live_streaming' || (postType === 'home' && sliderPostType === 'live_streaming')) {
                    // Get the live streaming options section
                    const liveStreamingOptions = currentSlider.find('.live_streaming_slider_options');
                    // Show live streaming options
                    liveStreamingOptions.show();
                    
                    // For home sliders, we need to use the correct post type in the selector
                    const effectivePostType = postType === 'home' ? postType : postType;
                    
                    // Correct selector for filter select
                    const filterSelect = currentSlider.find(`#live_streaming_select_filters_${effectivePostType}_${relValue}`);

                    
                    if (filterSelect.length) {
                        // Get the saved filter value
                        const savedFilterValue = filterSelect.val();
                        
                        if (savedFilterValue) {
                            // Set the filter value and trigger select2:select
                            filterSelect.val(savedFilterValue).trigger('select2:select');
                            // Manually trigger the filter change handler
                            this.OperateSliderrInnerSection(liveStreamingOptions[0], savedFilterValue);
                        }
                    }
                } else {
                    // Hide live streaming options for other post types
                    currentSlider.find('.live_streaming_slider_options').hide();
                }
                
                // Initialize Select2 for all select elements in this slider
                currentSlider.find('select').each(function() {
                    if (!jQuery(this).hasClass('select2-initialized')) {
                        jQuery(this).select2({
                            width: '100%'
                        }).addClass('select2-initialized');
                    }
                });
            });
        });
    }

    liveStreamingSubmit(event) {
        event.preventDefault();
        const submitButton = jQuery('#st-admin-option-dashboard-live-streaming button[type="submit"]');
        submitButton.attr('disabled', true);

        if (!this.validateForm()) {
            submitButton.attr('disabled', false);
            return;
        }

        const bannersData = this.getBannersData();
        const sliderData = this.getSliderData();

        if (bannersData.length === 0 && sliderData.length === 0) {
            notificationToast.error('Please add content for a better app experience.', 'Error', { preventDuplicates: true });
            submitButton.attr('disabled', false);
            return;
        }

        const formData = {
            banners: bannersData,
            sliders: sliderData
        };

        const data = {
            formData: formData,
            _ajax_nonce: LSAjax._ajax_nonce
        };

        post('ls_submit_dashboard_data', data)
            .then(response => {
                if (response.success) {
                    notificationToast.success(response.data.message || 'Data saved successfully', 'Success', { preventDuplicates: true });
                    jQuery(document).trigger('ls_dashboard_data_saved');
                } else {
                    notificationToast.error(response.data.message || 'Failed to save data', 'Error', { preventDuplicates: true });
                }
            })
            .catch(error => {
                notificationToast.error(error.message || 'An unexpected error occurred', 'Error', { preventDuplicates: true });
            })
            .always(() => {
                submitButton.attr('disabled', false);
            });
    }

    validateForm() {
        let isValid = true;
        let errorMessages = [];

        // Validate banners
        jQuery('.banner_display_list').each(function() {
            const image = jQuery(this).find('.upload_video_id').val();
            if (!image) {
                jQuery(this).find('.banner-error-msg').show();
                isValid = false;
                errorMessages.push('Please upload an image for all banners');
            } else {
                jQuery(this).find('.banner-error-msg').hide();
            }
        });

        if (!isValid) {
            // Show all error messages
            const uniqueMessages = [...new Set(errorMessages)];
            this.showNotice(uniqueMessages.join('<br>'), 'error');
        }

        return isValid;
    }

    getBannersData() {
        const bannersData = [];
        // Only select banners from the live streaming section
        jQuery('#admin_live_streaming_tab .banner_display_list').each(function() {
            const bannerType = jQuery(this).find('#banner_type').val();
            const bannerSelectItem = jQuery(this).find('select[name^="banner_select_item"]').val();
            const bannerImage = jQuery(this).find('.upload_video_id').val();

            bannersData.push({
                type: bannerType,
                selectItem: bannerSelectItem,
                image: bannerImage
            });
        });
        return bannersData;
    }

    getSliderData() {
        const sliderData = [];
        // Only select sliders from the live streaming section
        jQuery('#admin_live_streaming_tab .streamit_api_single_slider').each(function() {
            const slider = jQuery(this);
            const relValue = slider.attr('rel');
            const type = slider.find('#type').val();
            const postType = slider.find(`#slider_post_type_${type}_${relValue}`).val() || type;

            // Get the filter value for live streaming
            const filterSelect = slider.find(`#live_streaming_select_filters_${type}_${relValue}`);
            const selectedFilterType = filterSelect.val();
            const livestreamingfilter = selectedFilterType ? [selectedFilterType] : [];
            
            // Get selected categories if the filter type is 'category'
            const livestreamingCategories = (selectedFilterType === 'category') ?
                (slider.find(`#live_streaming_slider_category_${type}_${relValue} option:selected`).map(function() {
                    return jQuery(this).val();
                }).get() || []) : [];

            // Get selected items if the filter type is 'selected'
            const livestreamingSelect = (selectedFilterType === 'selected') ?
                (slider.find(`#live_streaming_slider_selected_${type}_${relValue} option:selected`).map(function() {
                    return jQuery(this).val();
                }).get() || []) : [];

            const data = {
                rel_value: relValue,
                title: slider.find('[id="slider_title"]').val() || '',
                view_all: slider.find('[id="view_all"]').is(':checked') ? 'true' : 'false',
                post_type: postType,
                livestreamingfilter: livestreamingfilter,
                livestreamingCategories: livestreamingCategories,
                livestreamingSelect: livestreamingSelect
            };

            sliderData.push(data);
        });
        return sliderData;
    }


    refreshData() {
        jQuery(document).trigger('ls_refresh_data');
    }

    manageSliderOptions(value, element, post_type, rel_value) {
        // Find the nearest .streamit_api_single_slider container from the passed element
        const sliderContainer = element.closest('.streamit_api_single_slider');

        // Hide all sections by default
        const allOptions = sliderContainer.querySelectorAll('.movie_slider_options, .video_slider_options, .tvshow_slider_options, .live_streaming_slider_options');
        allOptions.forEach(option => option.style.display = 'none');

        // Show the selected section based on post type
        let innsersecton;
        if (value === 'live_streaming' || (post_type === 'home' && value === 'live_streaming')) {
            innsersecton = sliderContainer.querySelector('.live_streaming_slider_options');
            if (innsersecton) {
                innsersecton.style.display = 'block';
                // After showing the appropriate section, manage the 'select_fillters' logic
                this.manageFilterOptions(innsersecton, value, post_type, rel_value);
            }
        }
    }

    // Function to manage filter options (category, selected) based on the selected filter value
    manageFilterOptions(innsersecton, value, post_type, rel_value) {
        const FiltterId = '#live_streaming_select_filters_' + post_type + '_' + rel_value;
        const filterSelect = innsersecton.querySelector(FiltterId);

        // Check if filterSelect exists
        if (filterSelect) {
            const selectedFilter = filterSelect.value;
            this.OperateSliderrInnerSection(innsersecton, selectedFilter);
        }
    }

    // Function to handle the visibility of category and selected sections
    OperateSliderrInnerSection(innsersecton, value) {
        if (!innsersecton) return;

        const categorySection = innsersecton.querySelector('.category');
        const selectedSection = innsersecton.querySelector('.selected');

        // Hide both sections by default
        if (categorySection) categorySection.style.display = 'none';
        if (selectedSection) selectedSection.style.display = 'none';

        // Show only the relevant section based on filter type
        if (value === 'category' && categorySection) {
            categorySection.style.display = 'block';
        } else if (value === 'selected' && selectedSection) {
            selectedSection.style.display = 'block';
        }

    }
}
